import { render, staticRenderFns } from "./priceModal.vue?vue&type=template&id=4e68354a&scoped=true&"
import script from "./priceModal.vue?vue&type=script&lang=js&"
export * from "./priceModal.vue?vue&type=script&lang=js&"
import style0 from "./priceModal.vue?vue&type=style&index=0&id=4e68354a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e68354a",
  null
  
)

export default component.exports